export default "__VITE_ASSET__CC58J5mm__"